<template>
  <div class="modalContent">
    <section v-if="!submitted" class="  mt-4  text-white" id="contact">
      <div>
        <h5 class="ml-4">Get Quote</h5>
        <b-form @submit.prevent="sendMail" class="p-4 modalContent__form">
          <div class="d-flex selectorIconContainer  align-items-center">
            <font-awesome-icon
              class="input-portfolio1-container__icon"
              :icon="['fas', 'desktop']"
            />
            <div class="selectorContainer">
              <b-form-select
                class="input-portfolio1  modalContent__categoryselector"
                v-model="selected"
                :options="options"
                required
              >
                <font-awesome-icon
                  class="input-portfolio1-container__icon"
                  :icon="['fas', 'pager']"
                />
              </b-form-select>
            </div>
            <font-awesome-icon
              class="input-portfolio1-container__icon ml-auto"
              :icon="['fas', 'sort-down']"
            />
          </div>
          <b-form-textarea
            id="textarea"
            v-model="details"
            placeholder="Please discuss about your application (optional)"
            rows="4"
            max-rows="6"
            class="textarea-portfolio1 mt-4"
          ></b-form-textarea>
          <b-form-group
            v-for="(el, index) in form"
            :key="index"
            class="input-portfolio1-container my-3"
            :class="{ focused: el.focused }"
          >
            <font-awesome-icon
              class="position-absolute input-portfolio1-container__icon"
              :icon="['fas', el.icon]"
            />
            <b-form-input
              @focus="el.focused = true"
              @blur="el.focused = false"
              class="input-portfolio1 pl-4"
              v-model="el.value"
              :type="el.type"
              required
              :placeholder="el.placeholder"
            ></b-form-input>
          </b-form-group>

          <button
            class="d-flex justify-content-center align-items-center btn btn-portfolio1 mt-3 d-block  text-portfolio4 font-weight-bold letter-spacing-md text-uppercase contact-btn"
          >
            <b-spinner
              v-if="showspinner"
              small
              label="Small Spinner mx-1"
            ></b-spinner>
            <p class="text-center my-2 mx-1">Submit</p>
          </button>
        </b-form>
      </div>
    </section>
    <div
      v-if="submitted"
      class="d-flex justify-content-center align-items-center text-center px-4 py-5"
    >
      <h5 class="text-center text-white">
        Your Request is Submitted we will contact you shortly.
      </h5>
      <div class="text-right w-100">
        <button
          class="btn btn-portfolio1 mt-3  text-portfolio4 font-weight-bold letter-spacing-md text-uppercase contact-btn"
          @click="closeModal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      submitted: false,
      showspinner: false,
      details: "",
      form: [
        {
          fieldname: "pages",
          label: "Number of pages",
          value: "",
          focused: false,
          type: "text",
          placeholder: "Number of pages / screens (optional)",
          icon: "pager",
        },
        {
          fieldname: "mail",
          label: "email",
          value: "",
          focused: false,
          type: "email",
          placeholder: "Enter Email",
          icon: "envelope",
        },
      ],
      selected: null,
      options: [
        { value: null, text: "Please Select Type Of Application" },
        { value: "website", text: "Website" },
        { value: "ios", text: "Apple Iphone(IOS APP)" },
        { value: "android", text: "Android APP" },
        { value: "mobileapp", text: "Hybrid Mobile App (IOS+ANDROID)" },
        { value: "desktop", text: "Desktop Application" },
      ],
    };
  },

  methods: {
    closeModal() {
      this.$store.commit("quoteModal", false);
    },
    makeToast(msg, type) {
      this.$toast.open({
        message: `${msg}`,
        type: type,
        position: "top-right",
      });
    },
    sendMail() {
      this.showspinner = true;
      let email;
      let pages;

      this.form.forEach((el) => {
        if (el.fieldname == "pages") {
          pages = el.value;
        }
        if (el.fieldname == "mail") {
          email = el.value;
        }
      });

      let params = {
        from: email,
        pages: pages,
        applicationType: this.selected,
        details: this.details,
      };
      axios
        .post("https://www.robustoffice.com/get/quote", params)
        .then((res) => {
          if (res.data.accepted.length > 0) {
            this.makeToast("Message Sent Successfully.", "success");

            // this.form.forEach((el) => {
            //   if (el.label == "subject") {
            //     el.value = "Subject";
            //   }
            //   if (el.label == "email") {
            //     el.value = "Email";
            //   }
            //   this.message = "Message";
            // });
            this.showspinner = false;
            this.submitted = true;
          }
        })
        .catch((err) => {
          this.showspinner = false;
          this.makeToast(err.message, "danger");
          console.error(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
